__turbopack_context__.v({
  "description": "intro-module-scss-module__c7pu9G__description",
  "intro": "intro-module-scss-module__c7pu9G__intro",
  "introAnimatedTitle": "intro-module-scss-module__c7pu9G__introAnimatedTitle",
});
